import React, {useEffect, useMemo, useState} from 'react';
import {NavLink, useHistory, useParams} from "react-router-dom";
import useAPI from "../../../../hooks/useAPI";
import useToast from "../../../../hooks/useToast";
import {useStore} from "../../../../stores/StoreHelpers";
import useUserContext from "../../../../hooks/useUserContext";
import {useRequestObject} from "../../../../hooks/useRequestObject";
import {IncomesRequests} from "../../../../requests/PortfolioRequests/IncomesRequests";
import {newYears, tableIcons, years} from "../../../../helpers";
import {status_ru} from "../../../../helpers/PortfolioProject/IncomeHelper";
import StatusBadge from "../../../../components/common/StatusBadge";
import MaterialTable, {MTableAction, MTableBody, MTableToolbar} from "material-table";
import {
    getStickyActionAndStatus,
    LocalizationWithSmallActions,
    modifyDefaultOptions,
    objectToCols, styledHeaderSticky, arrayToLookup
} from "../../../../helpers/table";
import MTableHeader from "../../../../components/material-table-overrides/MTableHeader";
import {ThreeDRotation} from "@material-ui/icons";
import RegisterFilterRow from "../../../../components/RegisterFilterSection/RegisterFilterRow";
import RegisterFilterSelectorGroup from "../../../../components/RegisterFilterSection/RegisterFilterSelectorGroup";
import style from "../../../../components/project/Widgets/Articles/style.module.less";
import {Spinner} from "react-bootstrap";
import {observer} from "mobx-react";
import moment from "moment";
import DownloadLink from "../../../../components/common/DownloadLink";
import {isAdmin, isPortfolioTeam, isProjectTeam} from "../../../../services/rolesSvc";
import TooltippedElement from "../../../../components/common/TooltippedElement";
import ModalSendForRevision from "../../../../components/common/ModalSendForRevision";
import ConfirmModal from "../../../../components/common/ConfirmModal";
import HintCard from "../../../../components/common/HintCard/HintCard";
import FilterMultiSelect from '../../../../components/table/FilterMultiSelect';

const IncomesTable = observer(({navCtx, portfName}) => {
    const {stratId, portfolioId} = useParams()
    const api = useAPI()
    const addToast = useToast()
    const store = useStore().incomeProj
    const userCtx = useUserContext()
    const history = useHistory()
    // const [filesModalOpen,setFilesModalOpen] = useState(null)
    // const [resultModalOpen,setResultModalOpen] = useState(null)
    const [currentDataSet, setCurrentDataSet] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const editable = useMemo(() => isAdmin(userCtx) || isPortfolioTeam(userCtx, portfolioId), [userCtx]);

    const requests = useRequestObject({classType:IncomesRequests,api,addToast,store,portfolioId,stratId})

    useEffect(() => {
        requests.getAllPortfolioInComes().then(x => setCurrentDataSet(x))
        setIsLoaded(true)
    }, [])

    useEffect( ()=>{
        updateTableData()
    },[store.allIncomes,store.filters])


    const updateTableData = () => {
        let currData = store?.allIncomes?.data ? [...store?.allIncomes?.data] : null
            if(!!currData) {
                setCurrentDataSet(currData.map(x => {
                    return {
                        ...{
                            headCol: `${x?.head?.lastName} ${x?.head?.firstName} ${x?.head?.middleName ?? ''}`,
                            headName: `${x?.proj?.head?.displayName}`,
                            projName: `${x?.proj?.fullNumber} ${x?.proj?.name}`
                        }
                        , ...x
                    }

                }).slice().reverse())
                setIsLoaded(true)
            }
            else
                setIsLoaded(false)

    };

    const optionsIncomeYear = [{value: 'null', label: 'Не указан'}, ...newYears.map((val, index) => {
        return {value: val, label: val}
    })]
    const optionsIncomeStatus = [{value:null,label:'Не указан'},...Object.entries(status_ru).map((val, index)=> {
        return {value:val[0],label:val[1]}
    })]

    const [isModalDelete, setIsModalDelete] = useState({
        show: false,
        value: null,
    });
    const [isModalReject, setIsModalReject] = useState({
        show: false,
        value: null,
    });

    const handleReject = async (comment) => {
        await requests.rejectIncome(isModalReject.value, comment);
        setIsModalReject({show: false, value: null});
    }
    const handleDelete = async () => {
        requests.deleteIncomeById(isModalDelete.value).then(() => history.push(`/strats/${stratId}/portfolios/${portfolioId}/report/income`));
        setIsModalDelete({show: false, value: null});
    };

    const actions = {
        edit: (id, rowData) => {
            store.setFormObject(rowData);
            history.push(`/strats/${navCtx.strategy.id}/portfolios/${portfolioId}/projs/${rowData?.projId}/report/income/${id}?isEdit=true`)
        },
        send: async (id) => await requests.sendIncome(id),
        approve: async (id) => await requests.approveIncome(id),
        reject: async (id) => setIsModalReject({show: true, value: id}),
        delete: async (id) => setIsModalDelete({show: true, value: id}),
    };

    const allColumns = [
        ...getStickyActionAndStatus(actions, userCtx, stratId, portfolioId, 'income'),
        {
            title: '№ и Название проекта', field: 'projName',
            lookup: arrayToLookup("projName", currentDataSet),
            filterComponent: FilterMultiSelect,
            filtering: true,
            sorting: true,
            width: '270px',

        },
        {
            title: 'Руководитель проекта', field: 'headName',
            filtering: true,
            sorting: true,
            width: '270px',
            lookup: arrayToLookup("headName", currentDataSet),
            filterComponent: FilterMultiSelect,

        },
        {
            title: 'Наименование темы',
            field: 'topic',

            filtering: true,
            sorting: true,
            render: (rowData) => <NavLink onClick={() => store.setFormObject(rowData)}
                                          to={`/strats/${navCtx.strategy.id}/portfolios/${portfolioId}/projs/${rowData?.projId}/report/income/${rowData.id}?isEdit=false`}>{rowData?.topic}</NavLink>,
            width: '250px'

        },
        {
            title: '№ темы',
            field: 'topicNum',

            filtering: true,
            sorting: true,
            width: '150px'

        },
        {
            title: 'Объем реализации за отчетный год (тыс. руб.)',
            field: 'salesVolume',

            filtering: true,
            sorting: true,
            width: '300px'

        },
        {
            title: 'Руководитель темы',
            field: 'headCol',
            lookup: arrayToLookup("headCol", currentDataSet),
            filterComponent: FilterMultiSelect,
            filtering: true,
            sorting: true,
            width: '200px'

        },
        {
            title: 'Институт (где работает руководитель темы)',
            field: 'institute',

            filtering: true,
            sorting: true,
            width: '280px',
            lookup: arrayToLookup("institute", currentDataSet),
            filterComponent: FilterMultiSelect,

        },
        {
            title: 'Год',
            field: 'year',
            lookup: arrayToLookup("year", currentDataSet),
            filterComponent: FilterMultiSelect,
            filtering: true,
            sorting: true,
            width: '130px'

        },
        {
            title: 'Тип дохода',
            field: 'type',
            lookup: arrayToLookup("type", currentDataSet),
            filterComponent: FilterMultiSelect,
            filtering: true,
            sorting: true,
            width: '180px'

        },
        {
            title: 'Заказчик',
            field: 'customer',

            filtering: true,
            sorting: true,
            width: '250px'

        },
    ]


    const incomeTable = useMemo(() => {
        return (
            <>
                <MaterialTable
                title=""
                    options={modifyDefaultOptions({
                        padding: 'default',
                        filtering: true,
                        sorting: true,
                        search: false,
                        toolbar: true,
                        tableLayout: 'auto',

                        maxBodyHeight: 'calc(100vh - 376px)',
                        headerStyle: {
                            fontSize: '12px',
                            zIndex: 0

                        },
                        filterCellStyle: {
                            position: "sticky",
                            top: 48,
                            background: 'white',
                        },
                    })}
                    columns={!!allColumns && objectToCols(allColumns)}
                    data={currentDataSet}
                    localization={LocalizationWithSmallActions}
                    icons={tableIcons}
                    components={{
                        Container: (props) => <div className="special-filter-without-max" {...props} />,
                        Toolbar:(props)=>(
                            <div className={'d-flex justify-content-between'}>
                                <div style={{marginBottom:'2rem'}}>
                                    {selectors}
                                </div>
                                <MTableToolbar {...props}/>
                            </div>
                        ),
                        Body: (props) => (
                            <>
                                <MTableBody {...props}/>
                                <div id="portal-root"></div>
                            </>
                        ),
                        Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky}/>),

                    }}

                />
            </>
        )
    }, [currentDataSet])

    const selectors = (
        <RegisterFilterRow
            buttonCreatorObject={[
                {
                    title: 'Выгрузить в xls', custom: (
                        <DownloadLink variant="outline-primary"
                                      url={`/factdata/incomes/0/export?portfId=${portfolioId}${!!store.filters?.year ?`&year=${store.filters?.year}` : ''}`}
                                      filename={`Доходы портфель проектов (${portfName})_${moment().format('DD.MM.YYYY')}.xlsx`}>
                            Выгрузить в xls
                        </DownloadLink>
                    )
                }
            ]}>
            <RegisterFilterSelectorGroup

                selectors={[
                    {
                        label: 'Год',
                        minWidth:144,
                        selectorOptions: {
                            defaultValue: optionsIncomeYear[0],
                            defaultOptions: optionsIncomeYear,
                            value: !store.filters['year'] ? optionsIncomeYear[0] : {
                                value: store.filters['year'],
                                label: store.filters['year']
                            },
                            onChange: (e) => {
                                store.changeFilter(`year`, e.value)
                                    .then(()=>requests.getAllPortfolioInComes())
                                // .then()
                            }
                        }
                    },
                    {
                        label: 'Статус',
                        minWidth:170,
                        selectorOptions: {
                            defaultValue: optionsIncomeStatus[0],
                            defaultOptions: optionsIncomeStatus,
                            value: !store.filters['status'] ? optionsIncomeStatus[0] : {
                                value: store.filters['status'].value,
                                label: store.filters['status'].label
                            },
                            onChange: (e) => {
                                store.changeFilter(`status`, e)
                                    .then(()=>requests.getAllPortfolioInComes())

                                    .then(()=>setCurrentDataSet(store.allIncomes.data))
                            }
                        }
                    },
                ]}
            />
        </RegisterFilterRow>
    )

    return isLoaded ? (
            <React.Fragment>
                <HintCard
                    cardStyles={{fontSize: '18px',marginTop:0,fontsize:'18px'}}
                    noGutter={true}
                    rowStyles={{padding:0,margin:'auto',marginBottom:'1em'}}
                    text={"Для добавления статей/доходов/заявок в проект, убедитесь, что заполнен реестр «Участники»"}
                />
                <div className={style.tableWrapper}>
                    {incomeTable}
                </div>
                <ModalSendForRevision
                    show={isModalReject.show}
                    onClose={() => setIsModalReject({show: false, value: null})}
                    onSubmit={(comment) => handleReject(comment)}
                    headerText="Не согласовать"
                    label="Комментарий"
                />
                <ConfirmModal
                    show={isModalDelete.show}
                    onClose={() => setIsModalDelete({show: false, value: null})}
                    onConfirm={() => handleDelete()}
                    headerText="Удаление объема доходов"
                    message="Объем доходов будет удален, данное действие нельзя отменить. Удалить объем доходов?"
                />
            </React.Fragment>
        )
        : (
            <Spinner animation={"border"} style={{width: '4rem', height: '4rem'}}/>
        );
});

export default IncomesTable;
